import { autoinject, computedFrom } from "aurelia-framework";

import { ServiceCallQuotationDetailsModel } from "api/models/company/service-call/service-call-quotation-details-model";
import { ServiceQuotationSecuritySettingsModel } from "api/models/company/security/service-quotation-security-settings-model";

import routerHelper from "helpers/routerHelper";
import RouteRepository from "repositories/routeRepository";
import { ServiceCallQuotationService } from "services/service-call-quotation-service";
import { ServiceCallQuotationSecurityService } from "services/service-call-quotation-security-service";

import { ServiceCallQuotationItemModel } from "api/models/company/service-call/service-call-quotation-item-model";
import { ServiceCallQuotationEquipmentModel } from "api/models/company/service-call/service-call-quotation-equipment-model";

export interface QuotationItemsParameters {
    quotationId: number;
}

@autoinject()
export class QuotationAddedEquipments {
    public quotation: ServiceCallQuotationDetailsModel | null = null;
    public securitySettings: ServiceQuotationSecuritySettingsModel | null = null;

    private quotationId: number = 0;

    @computedFrom("quotation", "quotation.Status", "securitySettings")
    public get readonly(): boolean {
        return this.serviceCallQuotationSecurityService.isQuotationReadOnlyInMobile(this.quotation, this.securitySettings);
    }

    constructor(
        private readonly serviceCallQuotationService: ServiceCallQuotationService,
        private readonly serviceCallQuotationSecurityService: ServiceCallQuotationSecurityService,
        private readonly routeRepository: RouteRepository) {
    }

    public async activate(params: QuotationItemsParameters): Promise<void> {
        await Promise.all([this.initQuotation(params.quotationId), this.initSecuritySettings()]);
    }

    public gotoItem(lineNumber: number): Promise<void> {
        return routerHelper.navigateToRoute(this.routeRepository.routes.Service_Quotation_Added_Equipment.name, {
            quotationId: this.quotationId,
            quotation: this.quotation,
            lineNumber: lineNumber
        });
    }

    public async deleteItem(item: ServiceCallQuotationItemModel): Promise<void> {
        if (!this.quotation) {
            return;
        }

        this.quotation.EquipmentsToAdd = this.quotation.EquipmentsToAdd!.filter((equip: ServiceCallQuotationEquipmentModel) => equip.LineNumber !== item.LineNumber);

        await this.serviceCallQuotationService.saveQuotation(this.quotation, true, true);
        await this.initQuotation(this.quotationId);
    }

    private async initQuotation(quotationId: number): Promise<void> {
        this.quotationId = quotationId;
        this.quotation = await this.fetchQuotation(Number(quotationId));
    }

    private async initSecuritySettings(): Promise<void> {
        this.securitySettings = await this.serviceCallQuotationSecurityService.getSecuritySettings();
    }

    private async fetchQuotation(quotationId: number): Promise<ServiceCallQuotationDetailsModel> {
        return await this.serviceCallQuotationService.getQuotation(quotationId, true, false, false, false, false);
    }
}
